// extracted by css-extract-rspack-plugin
export default {"cls1":"Accordion-cls1_bbu","cls2":"Accordion-cls2_t2t Accordion-cls1_bbu","open":"Accordion-open_uQj"};